import { useEffect } from "react";
import { toastTypes, toastStyled } from "data/toast";
import { anyPendingChanges } from "data/offline/offlineQueue";

export function usePendingOfflineChanges(itemUri: string) {
    // const [hasPendingChanges, setHasPendingChanges] = useState(false);
    useEffect(() => {
        if (itemUri != null) {
            anyPendingChanges(itemUri).then((result) => {
                if (result === true) {
                    toastStyled(toastTypes.offlinePendingChanges);
                }
                // setHasPendingChanges(result);
            });
        }
    }, [itemUri]);

    // useEffect(() => {
    //     if (hasPendingChanges === true) {
    //         toastStyled(toastTypes.offlinePendingChanges);
    //     }
    // }, [hasPendingChanges]);
}
